import styled from "styled-components"

import { breakpoint } from "@minuthq/meatball-ui-react"

import { mainContentPadding } from "src/components/AppLayout/sharedStyles"
import { MinutAIKnowledge } from "src/components/MinutAI/MinutAIKnowledge/MinutAIKnowledge"
import { MinutAISuggestions } from "src/components/MinutAI/MinutAISuggestions/MinutAISuggestions"
import { useTranslate } from "src/i18n/useTranslate"
import { Container } from "src/ui/Container/Container"
import { Titlebar } from "src/ui/Layout/Titlebar"
import { spacing } from "src/ui/spacing"
import { ITab } from "src/ui/Tabs/Tab"
import { TabPanel } from "src/ui/Tabs/TabPanel"
import { Tabs } from "src/ui/Tabs/Tabs"

export function MinutAI() {
  const { tPlaceholder } = useTranslate()

  const tabs: ITab[] = [
    {
      id: "knowledge",
      label: tPlaceholder("Knowledge"),
      view: <MinutAIKnowledge />,
    },
    {
      id: "suggestions",
      label: tPlaceholder("Suggestions"),
      view: <MinutAISuggestions />,
    },
  ]

  return (
    <Container>
      <Wrapper>
        <Titlebar title={tPlaceholder("Minut AI")} bottomMargin={spacing.M} />
        <Tabs labels={tabs}>
          {tabs.map((tab) => (
            <StyledTabPanel key={tab.id}>{tab.view}</StyledTabPanel>
          ))}
        </Tabs>
      </Wrapper>
    </Container>
  )
}

const Wrapper = styled.div`
  ${mainContentPadding}

  @container (${breakpoint.mediumUp}) {
    display: grid;
    grid-template-rows: auto auto 1fr;
    height: 100vh;
    overflow: hidden;
  }
`

const StyledTabPanel = styled(TabPanel)`
  margin-top: ${spacing.L};
  overflow: auto;
`
